import React from 'react';
import { useStateContext } from '../../contexts/ContextProvider';
import { Toaster } from 'react-hot-toast';
import CardPlanesServiciosInfo from "../../components/Cards/CardPlanesServiciosInfo";

const PlanesServiciosInfo = () => {
  const { currentColor } = useStateContext();

  return (
    <form>
      <div className="m-2 md:m-10 mt-16 p-4 bg-gray-100 rounded-3xl">
        <div className="container mx-auto">
          <div className="flex justify-between items-center px-4 py-4 border-b border-gray-200 bg-white rounded-t-md shadow-sm">
            <div className="flex items-center gap-2">
              <div className="w-2.5 h-2.5 rounded-full bg-green-800 animate-pulse" />
              <p className="text-gray-800 font-semibold text-lg">Planes y Servicios</p>
            </div>
          </div>

          <div className="bg-gray-100 p-6 mt-4 rounded-lg shadow-inner">
            <CardPlanesServiciosInfo />
          </div>

          <Toaster
            position="top-right"
            toastOptions={{
              style: { zIndex: 9999 },
            }}
          />
        </div>
      </div>
    </form>
  );
};

export default PlanesServiciosInfo;
